import { useEffect, useRef, useState } from "react";
import SupportMessage from "./SupportMessage"; 
import "../Css/supportPanel.css";
import steps from "../data/SupportSteps";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Toast } from "primereact/toast";

function SupportFlow({ extraInfo, onSendExtraInfo ,onClosePannel }) {
  
  const user = JSON.parse(localStorage.getItem('flickerNetwork') != null) ? JSON.parse(localStorage.getItem('flickerNetwork')) : {username:"" , name:"", avatarPic:"profile-index.png"};
  const token = JSON.parse(localStorage.getItem('userToken'));
  const config = {  headers: {"Content-Type": "application/json",Authorization: `Bearer ${token}`} };
  const navigate = useNavigate();
  const [userResponses, setUserResponses] = useState({});
  const [currentStep, setCurrentStep] = useState("start");
  const messagesEndRef = useRef(null);
  const toast = useRef(null);
  const [messages, setMessages] = useState([
    { type: 1, text: steps.start.message, options: steps.start.options },
  ]);
  const [selectedProduct,setSelectedProduct] = useState();
  const [sellers_ids,setSellers_ids] = useState([]);
  const [sellers_links,setSellers_links] = useState([]);
  const [order_id,setOrder_id] = useState();

  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollTop = messagesEndRef.current.scrollHeight;
    }
  };

  useEffect(() => {
 
    
    if(currentStep!="start")
    scrollToBottom();
  }, [messages]);

  // handle user interactions: *************************************************************************
  const handleOptionClick = (option) => {


    if(currentStep==="start")
      setSelectedProduct(option);
    
    // نمایش پاسخ کاربر
    setMessages((prev) => [
      ...prev,
      { type: 2, text: option.label, options: [] },
    ]);

    // ذخیره پاسخ
    setUserResponses((prev) => ({
      ...prev,
      [currentStep]: option.label,
    }));

    const nextStepKey = option.next;
    const nextStep = steps[nextStepKey];

    //ثبت سفارش و پیدا کردن فروشنده ها
    if(nextStepKey==="final_message")
    {
      
         saveFinalOrder({ ...userResponses, [currentStep]: option.label }, extraInfo);




    }



    if (nextStepKey === "send_to_whatsapp") {
      // ارسال پیام نهایی
      sendWhatsAppMessage({ ...userResponses, [currentStep]: option.label }, extraInfo);

      return;
    }

    if (nextStep) {
      setCurrentStep(nextStepKey);
      setTimeout(() => {
        setMessages((prev) => [
          ...prev,
          { type: 1, text: nextStep.message, options: nextStep.options || [] },
        ]);
      }, 500);
    }
  };

  /********************************************************************************************/ 



// وقتی کاربر توضیح اضافه زده
  // send extra info**************************************************************************:
  useEffect(() => {
  if (currentStep === "extra_info_input" && extraInfo && extraInfo.trim()) {
    // اول پیام رو اضافه کن به چت
    setMessages((prev) => [
      ...prev,
      { type: 2, text: extraInfo, options: [] },
    ]);

    if (onSendExtraInfo) {
      onSendExtraInfo();
    }

    // ثبت سفارش و پیدا کردن فروشنده‌ها
    saveFinalOrder({ ...userResponses, [currentStep]: extraInfo }, extraInfo);


    
    setCurrentStep("final_message");

    const nextStep = steps["final_message"];
setTimeout(() => {
  setMessages((prev) => [
    ...prev,
    { type: 1, text: nextStep.message, options: nextStep.options || [] },
  ]);
}, 500);

    
  }
  if (currentStep !== "extra_info_input" && extraInfo)
  {
    toast.current.show({severity: 'error', summary: 'لطفا یک محصول را انتخاب کنید یا \"بذار خودم توضیح بدم\" رو بزنید'});
    onSendExtraInfo();
  }
  if (currentStep === "extra_info_input" && extraInfo==="")
    toast.current.show({severity: 'error', summary: 'لطفا توضیح اضافه خود را وارد کنید'});

}, [extraInfo]);
/****************************************************************************************************/ 









// Save final order **************************************************************************
  const saveFinalOrder = async (responses, extraMessage) => {


    //close pannel:
    if (onClosePannel) {
  onClosePannel();
}

    let finalMessage = "\اطلاعات سفارش :\n";
    Object.entries(responses).forEach(([key, value]) => {
      const title = steps[key]?.title;
      if (title) {
        finalMessage += `${title}: ${value}\n`;
      }
    });

    if (extraMessage && extraMessage.trim()) {
      finalMessage += `توضیح اضافه: ${extraMessage.trim()}\n`;
    }

    




    //save order in DB:
    var tempOrder_id;
    const data = {tag:selectedProduct.tag , content:finalMessage};
    await axios.post(process.env.REACT_APP_BACK+"/orders", data, config)
                  .then((response) => {
  
                  if(response.status == 201)
                  {
                    tempOrder_id = response.data._id;
                    setOrder_id(tempOrder_id);
                
                    
                  }
                  })
                  .catch((error) => {
                    console.log("error",error);
                    if(error.response.data.statusCode===401)
                      navigate("/login")
                  });



    // find sellers for order
              await axios.get(process.env.REACT_APP_BACK+"/orders/findSellersForOrder/"+tempOrder_id, config)
                            .then(async(response) => {
            
                            if(response.status == 200)
                            {
                            
                              await setSellers_ids(response.data);

                            }
                            })
                            .catch((error) => {
                              console.log("error",error);
                              if(error.response.data.statusCode===401)
                                navigate("/login")
                            });

                
                            
              //create whatsapp links:
              await axios.get(process.env.REACT_APP_BACK+"/orders/createWhatsappLinks/"+tempOrder_id, config)
                            .then(async(response) => {
            
                            if(response.status == 200)
                            {
                          
                              await setSellers_links(response.data); 
                            }
                            })
                            .catch((error) => {
                              console.log("error",error);
                              if(error.response.data.statusCode===401)
                                navigate("/login")
                            });

  };
/*****************************************************************************************************/ 



// send message via whatsapp **************************************************************************
  const sendWhatsAppMessage = async (responses, extraMessage) => {


    //close pannel:
    if (onClosePannel) {
  onClosePannel();
}

    let finalMessage = "\u200Fسفارش جدید:\n";
    Object.entries(responses).forEach(([key, value]) => {
      const title = steps[key]?.title;
      if (title) {
        finalMessage += `${title}: ${value}\n`;
      }
    });

    if (extraMessage && extraMessage.trim()) {
      finalMessage += `توضیح اضافه: ${extraMessage.trim()}\n`;
    }

    const managerPhone = "989352333881";
    const whatsappURL = `https://wa.me/${managerPhone}?text=${encodeURIComponent(finalMessage)}`;
    window.open(whatsappURL, "_blank");







 

    



  };
/*****************************************************************************************************/ 

  return (
    <div>

      <Toast ref={toast} position="center"></Toast>

      <div className="support-message-container p-4 flex flex-col gap-3 max-w-md" ref={messagesEndRef}>
        {messages.map((msg, index) => (
          <SupportMessage
            key={index}
            type={msg.type}
            message={msg.text}
            options={msg.options}
            onOptionClick={handleOptionClick}
            finalMessage={currentStep==="final_message" && index===messages.length-1 ? true : false}
            sellers_id={currentStep==="final_message" && index===messages.length-1  ?  sellers_ids : null}
            sellers_links={currentStep==="final_message" && index===messages.length-1 ? sellers_links  : null}
            order_id={currentStep==="final_message" && index===messages.length-1 ? order_id  : null}
          />
        ))}
      </div>
    </div>
  );
}

export default SupportFlow;
